import IconChevronDown from '@zvuk-b2b/react-uikit/ui/icons/ChevronDown';
import IconChevronUp from '@zvuk-b2b/react-uikit/ui/icons/ChevronUp';
import React, { useState } from 'react';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import { DATA_TEST_IDS } from '../consts';
import { CollapsibleSectionProps } from './types';
import styles from './index.module.scss';

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({ title, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleIsCollapsed = React.useCallback(() => setIsCollapsed((value) => !value), []);

  return (
    <div
      className={styles.panel}
      data-testid={DATA_TEST_IDS.EXAMPLE_PANEL}>
      <Button
        type={ButtonType.PLAIN}
        elementId={DATA_TEST_IDS.EXAMPLE_TOGGLE}
        aria-expanded={!isCollapsed}
        className={styles.title}
        onClick={toggleIsCollapsed}>
        {title}
        {isCollapsed ? <IconChevronDown className={styles.chevron} /> : <IconChevronUp className={styles.chevron} />}
      </Button>
      {!isCollapsed && (
        <div
          className={styles.content}
          data-testid={DATA_TEST_IDS.EXAMPLE_CONTENT_WRAPPER}>
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
